import { InvoiceState, InvoiceResponse } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getOrderInvoice } from './checkout.services';

export const initialState: InvoiceState = {
    data: {} as InvoiceResponse,
    status: "loading",
    error: {}
}

export const InvoiceSlice = createSlice({
    name: 'invoice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getOrderInvoice.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getOrderInvoice.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getOrderInvoice.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const InvoiceReducer = InvoiceSlice.reducer